import { render, staticRenderFns } from "./OtpDescription.vue?vue&type=template&id=3a0f5d10&scoped=true&"
import script from "./OtpDescription.vue?vue&type=script&lang=js&"
export * from "./OtpDescription.vue?vue&type=script&lang=js&"
import style0 from "./OtpDescription.vue?vue&type=style&index=0&id=3a0f5d10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0f5d10",
  null
  
)

export default component.exports